import { render, staticRenderFns } from "./yuanLiaoAdd.vue?vue&type=template&id=5b213b71&scoped=true&"
import script from "./yuanLiaoAdd.vue?vue&type=script&lang=js&"
export * from "./yuanLiaoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b213b71",
  null
  
)

export default component.exports